import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {

    public transform(value, keys: string, term: string, removeFromArray = true) {
        if (!term) {
            if (removeFromArray) {
                return value;
            }
            return value.map(item => {
                item['__hide'] = false;
                return item;
            })
        }

        if (removeFromArray) {
            return (value || []).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
        }
        return (value || []).map((item) => {
            if (keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key]))) {
                item['__hide'] = false;
            } else {
                item['__hide'] = true;
            }
            return item;
        });
    }
}

@NgModule({
    declarations: [SearchPipe],
    exports: [SearchPipe]
})
export class  SearchPipeModule {}
